import MazeTree from './MazeTree'

export default MazeTree
